window.API_VERSION = window.storefrontApi.apiVersion
window.API_ACCESS = window.storefrontApi.token

function getFocusableElements (container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    )
  })
})

const trapFocusHandlers = {}

function trapFocus (container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  // removeTrapFocus()

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) { return }

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill () {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', event => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) { currentFocusedElement.classList.remove('focused') }

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true,
  )
}

// eslint-disable-next-line no-unused-vars
function pauseAllMedia () {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    )
  })
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach(video => video.pause())
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

// eslint-disable-next-line no-unused-vars
function onKeyUpEscape (event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor () {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    )
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) { this.input.dispatchEvent(this.changeEvent) }
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce (fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

// eslint-disable-next-line no-unused-vars
function fetchConfig (type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i]
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  const method = options.method || 'post'
  const params = options.parameters || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  countryDomid,
  provinceDomid,
  options,
) {
  this.countryEl = document.getElementById(countryDomid)
  this.provinceEl = document.getElementById(provinceDomid)
  this.provinceContainer = document.getElementById(
    options.hideElement || provinceDomid,
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry () {
    const value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince () {
    const value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler (e) {
    const opt = this.countryEl.options[this.countryEl.selectedIndex]
    const raw = opt.getAttribute('data-provinces')
    const provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const newOpt = document.createElement('option')
        newOpt.value = provinces[i][0]
        newOpt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(newOpt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions (selector, values) {
    // eslint-disable-next-line no-unused-vars
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor () {
    super()

    this.mainDetailsToggle = this.querySelector('details')
    this.closeFilterDrawer = this.querySelectorAll(
      '[data-filter-toggle="close"]',
    )

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents () {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    )
    this.closeFilterDrawer.forEach(toggle =>
      toggle.addEventListener('click', this.onCloseButtonClick.bind(this)),
    )
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    )
  }

  onKeyUp (event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector('summary'),
      )
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick (event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus () {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      )
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      )
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`,
        )
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        parentMenuElement && parentMenuElement.classList.add('submenu-open')
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus,
          )
      }, 100)
    }
  }

  openMenuDrawer (summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    if (summaryElement.closest('.facets-wrapper')) {
      summaryElement.closest('.facets-wrapper').style.zIndex = 5
    }
    if (document.querySelector('#FreeShippingBanner')) {
      document.querySelector('#FreeShippingBanner').style.zIndex = 0
    }
  }

  closeMenuDrawer (event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach(submenu => {
        submenu.classList.remove('submenu-open')
      })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    // eslint-disable-next-line no-undef
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)
    if (document.querySelector('#FreeShippingBanner')) {
      document.querySelector('#FreeShippingBanner').style.zIndex = ''
    }
  }

  onFocusOut (event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      ) { this.closeMenuDrawer() }
    })
  }

  onCloseButtonClick (event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu (detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    // eslint-disable-next-line no-undef
    removeTrapFocus(detailsElement.querySelector('summary'))
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    this.closeAnimation(detailsElement)
    if (document.querySelector('#FreeShippingBanner')) {
      document.querySelector('#FreeShippingBanner').style.zIndex = ''
    }

    if (detailsElement.closest('.facets-wrapper')) {
      detailsElement.closest('.facets-wrapper').style.zIndex = ''
    }
  }

  closeAnimation (detailsElement) {
    let animationStart

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  openMenuDrawer (summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header')
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    )
    this.header.classList.add('menu-open')

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer (event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove('menu-open')
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor () {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    )
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        ) { this.hide(event) }
      })
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback () {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show (opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide () {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    // eslint-disable-next-line no-undef
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor () {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor () {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent (focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true),
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      )
      if (focus) deferredElement.focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor () {
    super()
    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.enableSliderLooping = false
    this.currentPageElement = this.querySelector('.slider-counter--current')
    this.pageTotalElement = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    this.orientation = this.getSliderOrientation()
    this.initPages()
    const resizeObserver = new ResizeObserver(entries => this.initPages())
    resizeObserver.observe(this.slider)

    // eslint-disable-next-line no-undef
    this.slider.addEventListener('scroll', debounce(this.update.bind(this), 0))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))

    this.update()
  }

  initPages () {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0,
    )

    if (this.sliderItemsToShow.length < 2) {
      return
    }

    if (this.orientation === 'horizontal') {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft

      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop
      this.slidesPerPage = Math.floor((this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset)
    }
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1

    this.update()
  }

  resetPages () {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  async getScrollDirection () {
    return new Promise((resolve) => {
      const isHorizontal = this.orientation === 'horizontal'
      const initialScrollPosition = isHorizontal ? this.slider.scrollLeft : this.slider.scrollTop

      const onScroll = () => {
        const currentScrollPosition = isHorizontal ? this.slider.scrollLeft : this.slider.scrollTop
        this.slider.removeEventListener('scroll', onScroll)

        if (currentScrollPosition > initialScrollPosition) {
          resolve(isHorizontal ? 'right' : 'down')
        } else if (currentScrollPosition < initialScrollPosition) {
          resolve(isHorizontal ? 'left' : 'up')
        } else {
          resolve('none') // No change in scroll position
        }
      }

      this.slider.addEventListener('scroll', onScroll, { once: true })

      // In case the scroll event never fires (e.g., if there's no scrolling),
      // resolve the promise after a short delay to handle the immediate case.
      setTimeout(() => {
        this.slider.removeEventListener('scroll', onScroll)
        resolve('none')
      }, 100)
    })
  }

  getSliderOrientation () {
    if (this.slider.classList.contains('slider--vertical')) {
      return 'vertical'
    }
    return 'horizontal'
  }

  async update () {
    if (!this.slider || !this.nextButton) return
    this.scrollDirection = await this.getScrollDirection()
    const previousPage = this.currentPage

    // Calculate the current page based on scroll position
    if (this.orientation === 'horizontal') {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1
    } else {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1
    }

    // Update the current page and total pages elements
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage
      this.pageTotalElement.textContent = this.totalPages
    }

    // Dispatch a slideChanged event if the current page has changed
    if (this.currentPage !== previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }))
    }

    if (!this.enableSliderLooping) {
      const slideEl = this.sliderItemsToShow[this.currentPage - 1]
      // Check if the previous button should be disabled
      const isPrevButtonDisabled = this.orientation === 'horizontal'
        ? (this.isSlideVisible(slideEl) && this.slider.scrollLeft === 0)
        : (this.isSlideVisible(slideEl) && this.slider.scrollTop === 0)

      // Check if the next button should be disabled
      const isNextButtonDisabled = this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], -1)

      // Update button attributes based on visibility
      this.updateButtonAttributes(this.prevButton, isPrevButtonDisabled)
      this.updateButtonAttributes(this.nextButton, isNextButtonDisabled)
    }
  }

  updateButtonAttributes (button, isDisabled) {
    if (isDisabled) {
      button.setAttribute('disabled', 'disabled')
    } else {
      button.removeAttribute('disabled')
    }
  }

  isSlideVisible (element, offset = 0) {
    if (!element) return false

    let lastVisibleSlide = 0
    if (this.orientation === 'horizontal') {
      lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset

      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      )
    }

    lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset

    return (
      element.offsetTop + element.clientHeight <= lastVisibleSlide &&
      element.offsetTop >= this.slider.scrollTop
    )
  }

  onButtonClick (event) {
    event.preventDefault()

    const step = event.currentTarget.dataset.step || 1
    if (this.orientation === 'horizontal') {
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset

      this.slider.scrollTo({
        left: this.slideScrollPosition,
      })
    } else {
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + step * this.sliderItemOffset : this.slider.scrollTop - step * this.sliderItemOffset

      this.slider.scrollTo({
        top: this.slideScrollPosition,
      })
    }
  }

  scrollToSlide (index) {
    this.slideScrollPosition = this.sliderItemOffset * (index - 1)
    this.orientation = this.getSliderOrientation()

    const slide = this.slider.querySelector(`li:nth-child(${index})`)

    if (this.orientation === 'horizontal') {
      this.slider.scrollTo({
        left: slide.offsetLeft,
      })
    } else {
      this.slider.scrollTo({
        top: slide.offsetTop,
      })
    }
  }
}

customElements.define('slider-component', SliderComponent)

class SliderIndicators extends SliderComponent {
  constructor () {
    super()

    this.indicators = Array.from(this.querySelectorAll('slider-indicator'))
    this.slider = this.closest('slider-component')
    this.sliderUl = this.slider.querySelector('.slider')
    this.itemsInView = 0
    this.orientation = this.slider.getSliderOrientation()

    this.onIntersection = this.onIntersection.bind(this)
    this.onIndicatorClick = this.onIndicatorClick.bind(this)
    this.updateActiveIndicator = this.updateActiveIndicator.bind(this)

    this.observer = new IntersectionObserver(this.onIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    })
  }

  connectedCallback () {
    this.observer.observe(this.slider)
    this.setIndicatorsVisibility()

    this.indicators.forEach(indicator => {
      indicator.addEventListener('click', this.onIndicatorClick)
    })

    // eslint-disable-next-line no-undef
    this.sliderUl.addEventListener('scroll', debounce(this.updateActiveIndicator, 0))
    // eslint-disable-next-line no-undef
    window.addEventListener('resize', debounce(this.setIndicatorsVisibility.bind(this), 250))
  }

  disconnectedCallback () {
    this.observer.disconnect()
  }

  setIndicatorsVisibility () {
    this.itemsInView = this.checkItemsInView()
    const lastIndicatorIndex = this.indicators.length - (this.itemsInView - 1)

    this.indicators.forEach((indicator, i) => {
      indicator.style.display = i >= lastIndicatorIndex ? 'none' : 'block'
    })

    this.updateActiveIndicator()
  }

  checkItemsInView () {
    // Count how many items are in view to hide the last indicators
    const sliderWidth = this.sliderUl.clientWidth
    const sliderScrollLeft = this.sliderUl.scrollLeft

    return Array.from(this.sliderUl.querySelectorAll('.slider__slide')).reduce(
      (count, item) => {
        const { clientWidth, offsetLeft, clientHeight, offsetTop } = item
        const isVisible =
          this.orientation === 'horizontal'
            ? offsetLeft >= sliderScrollLeft && offsetLeft + clientWidth <= sliderScrollLeft + sliderWidth
            : offsetTop >= sliderScrollLeft && offsetTop + clientHeight <= sliderScrollLeft + sliderWidth

        return isVisible ? count + 1 : count
      },
      0,
    )
  }

  onIndicatorClick (event) {
    const indicator = event.currentTarget
    const index = indicator.dataset.index

    this.slider.scrollToSlide(index)

    setTimeout(() => {
      indicator.parentElement.querySelector('.slider-indicator--active')?.classList.remove('slider-indicator--active')
      indicator.classList.add('slider-indicator--active')
    }, 50)
  }

  onIntersection (entries) {
    const sliderInView = entries[0].isIntersecting

    if (sliderInView) {
      this.setIndicatorsVisibility()
    }
  }

  updateActiveIndicator () {
    const currentPage = this.slider.currentPage || 1
    let indicator = this.querySelector(`[data-index="${currentPage}"]`)

    if (indicator) {
      const activeIndicator = this.querySelector('.slider-indicator--active')
      const item = this.slider.querySelector(`li:nth-child(${indicator.dataset.index})`)

      if (this.slider.scrollDirection === 'down' && item.getBoundingClientRect().y > window.innerHeight) {
        indicator = indicator.previousElementSibling
      } else if (this.slider.scrollDirection === 'up' && item.getBoundingClientRect().y > 0) {
        indicator = indicator.previousElementSibling
      }

      activeIndicator?.classList.remove('slider-indicator--active')
      indicator.classList.add('slider-indicator--active')
    }
  }
}

window.customElements.define('slider-indicators', SliderIndicators)

class SlideshowComponent extends SliderComponent {
  constructor () {
    super()

    this.sliderControlWrapper = this.querySelector('.slider-buttons')
    this.enableSliderLooping = true

    if (!this.sliderControlWrapper) return

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    )

    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')
    this.autoplaySpeed = this.slider.dataset.speed * 1000
    this.autoplayButtonIsSetToPlay = true

    this.initEventListeners()
    this.setAutoPlay()
    this.play()
  }

  initEventListeners () {
    this.sliderControlLinksArray.forEach(link =>
      link.addEventListener('click', this.linkToSlide.bind(this)),
    )

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this))
    this.addEventListener('mouseover', this.focusInHandling.bind(this))
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this))
    this.addEventListener('focusin', this.focusInHandling.bind(this))
    this.addEventListener('focusout', this.focusOutHandling.bind(this))

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this),
    )
  }

  setAutoPlay () {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')
    this.autoplaySpeed = this.slider.dataset.speed * 1000

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this),
    )
    this.addEventListener('mouseover', this.focusInHandling.bind(this))
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this))
    this.addEventListener('focusin', this.focusInHandling.bind(this))
    this.addEventListener('focusout', this.focusOutHandling.bind(this))

    this.play()
    this.autoplayButtonIsSetToPlay = true
  }

  onButtonClick (event) {
    super.onButtonClick(event)
    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (!isFirstSlide && !isLastSlide) return

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }

  update () {
    super.update()
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')
    this.prevButton.removeAttribute('disabled')

    if (!this.sliderControlButtons.length) return

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active')
      link.removeAttribute('aria-current')
    })

    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    )
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    )
  }

  autoPlayToggle () {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }

  focusOutHandling (event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target)
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
    this.play()
  }

  focusInHandling (event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target)
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play()
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause()
    }
  }

  play () {
    this.slider.setAttribute('aria-live', 'off')
    clearInterval(this.autoplay)
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    )
  }

  pause () {
    this.slider.setAttribute('aria-live', 'polite')
    clearInterval(this.autoplay)
  }

  togglePlayButtonState (pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      )
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      )
    }
  }

  autoRotateSlides () {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }

  setSlideVisibility () {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a')
      if (index === this.currentPage - 1) {
        if (linkElements.length) {
          linkElements.forEach(button => {
            button.removeAttribute('tabindex')
          })
        }
        item.setAttribute('aria-hidden', 'false')
        item.removeAttribute('tabindex')
      } else {
        if (linkElements.length) {
          linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1')
          })
        }
        item.setAttribute('aria-hidden', 'true')
        item.setAttribute('tabindex', '-1')
      }
    })
  }

  linkToSlide (event) {
    event.preventDefault()
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage)
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define('slideshow-component', SlideshowComponent)

class VariantSelects extends HTMLElement {
  isQuickBuyDrawer = false
  form = false

  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
    setTimeout(() => this.onVariantChange(), 1)
  }

  quickBuyDrawerCheck () {
    return !!this.form.closest('quick-add-modal')
  }

  onVariantChange (e) {
    this.form = this.form || this.closest('.main-product__form').querySelector('product-form')
    this.isQuickBuyDrawer = this.quickBuyDrawerCheck()
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    // this.updatePickupAvailability();
    this.removeErrorMessage()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }

    this.trackVariantChange(e)
  }

  updateOptions () {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value,
    )
  }

  updateMasterId () {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia () {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    )
    mediaGalleries.forEach(mediaGallery =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    )

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    )
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    )
    modalContent.prepend(newMediaModal)
  }

  updateURL () {
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || this.isQuickBuyDrawer === true) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    )
  }

  updateShareUrl () {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl || this.isQuickBuyDrawer === true) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    )
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    )
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]')
      // issue here
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateVariantStatuses () {
    let selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1,
    )

    const optionType = selectedOptionOneVariants[0].options.includes('Bottom') ? 'Bottom' : 'Top'
    const hasBottomShapes = this.querySelectorAll('input[name="Style-bottom"]').length > 0

    if (optionType === 'Bottom' && hasBottomShapes) {
      const selectedShape = this.querySelector('.js.product-form__input input[name="Style-bottom"]:checked').value
      selectedOptionOneVariants = selectedOptionOneVariants.filter(option => option.options.includes(selectedShape))
    }

    const inputWrappers = [...this.querySelectorAll('.product-form__input')]

    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant => variant.available && variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`])

      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability (listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        )
      }
    })
  }

  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;

  //   if (this.currentVariant && this.currentVariant.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }

  removeErrorMessage () {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) {
      if (typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage()
      }
    }
  }

  renderProductInfo (skipPageUpdates = false) {
    const requestedVariantId = this.currentVariant.id

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return
        const oldPrice = document.getElementById(
          `price-${this.dataset.section}`,
        ).innerHTML

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        )
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        )
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        )

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination) { inventoryDestination.innerHTML = inventorySource.innerHTML }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden'),
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) {
          if (skipPageUpdates) {
            price.innerHTML = oldPrice
          }
        }

        if (inventoryDestination) {
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === '',
          )
        }

        if (this.dataset.enableNotify) {
          this.toggleAddButton(
            false,
            this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.notifyWhenAvailable,
            false,
            !this.currentVariant.available,
          )
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut,
            false,
            false,
          )
        }
      })
  }

  toggleAddButton (disable = true, text, modifyClass = true, enableNotify = false) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const buyButton = productForm.querySelector(
      '.shopify-payment-button button[data-testid="Checkout-button"]',
    )
    const addButtonText = productForm.querySelector('.product-form__submitText')
    if (!addButton) return

    const discontinuedRecs = productForm.closest('quick-add-modal') ? false : document.querySelector('discontinued-recommendations')
    if (discontinuedRecs) discontinuedRecs.dataset.show = false

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
      addButton.dataset.soldOut = true
      addButton.dataset.notifyMe = false

      if (discontinuedRecs) discontinuedRecs.dataset.show = true
    } else {
      buyButton?.removeAttribute('disabled')
      addButton.removeAttribute('disabled')
      if (!enableNotify) {
        addButtonText.textContent = window.variantStrings.addToCart
        addButton.dataset.soldOut = false
        addButton.dataset.notifyMe = false
      } else {
        addButtonText.textContent = window.variantStrings.notifyWhenAvailable
        addButton.dataset.soldOut = true
        addButton.dataset.notifyMe = true
      }
    }
  }

  trackVariantChange (e) {
    const productTitle = this.productTitle
    const productId = this.productId
    const variantId = this.currentVariant?.id
    if (!productTitle || !productId || !variantId) return

    const selectedOptionName = e.target?.name
    const selectedOptionValue = e.target?.value
    if (!selectedOptionName || !selectedOptionValue) return

    window.dispatchEvent(new CustomEvent('pdp-variant-change', {
      detail: {
        selectedOptionName,
        selectedOptionValue,
      },
    }))
  }

  setUnavailable () {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('.product-form__submitText')
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    )
    const sku = document.getElementById(`Sku-${this.dataset.section}`)

    if (!addButton) return
    addButtonText.textContent = window.variantStrings.soldOut
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')
  }

  getVariantData () {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  get productId () {
    return this.form?.dataset?.productId
  }

  get productTitle () {
    return this.form?.dataset?.productTitle
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  setInputAvailability (listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked,
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)

class SetVariantRadios extends VariantRadios {
  constructor () {
    super()
    this.updateOptions()
    this.updateMasterId()
    this.updateVariantInput()
    this.updateVariantStatuses()
  }

  onVariantChange (e) {
    this.form = this.form || this.closest('.main-product__form').querySelector('product-form')
    this.isQuickBuyDrawer = this.quickBuyDrawerCheck()
    this.updateOptions()
    this.updateMasterId()
    // this.updatePickupAvailability();
    this.removeErrorMessage()
    this.updateVariantStatuses()
    const type = this.dataset.type

    if (e?.target?.value) {
      const parentEl = e.target.closest('.product-form__input')
      const labelEl = parentEl.querySelector('.form__label')

      if (labelEl) {
        const valueEl = labelEl.querySelector('[data-value]')

        valueEl.textContent = e.target.value
      }
    }

    let otherId
    if (type === 'top') {
      otherId = parseInt(this.form.querySelector('input[name="bottom-id"]')?.value, 10)
    } else {
      otherId = parseInt(this.form.querySelector('input[name="top-id"]')?.value, 10)
    }

    const other = this.getVariantData().find(variant => variant.id === otherId)

    if (!this.currentVariant || !other?.available) {
      if (this.dataset.enableNotify) {
        this.toggleAddButton(
          false,
          window.variantStrings.notifyWhenAvailable,
          false,
          true,
        )
      } else {
        this.toggleAddButton(
          true,
          window.variantStrings.soldOut,
          false,
          false,
        )
        this.setUnavailable()
      }
    } else {
      this.toggleAddButton(false, window.variantStrings.soldOut, false)
      if (this.dataset.type === 'top') {
        this.updateMedia()
        this.updateURL()
      }

      this.renderProductInfo(this.dataset.type === 'bottom')
      if (this.dataset.type === 'top') {
        this.updateShareUrl()
      }
    }
    this.updateVariantInput()
    this.trackVariantChange(e)
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    )
    productForms.forEach(productForm => {
      const input = productForm.querySelector(
        `input[name="${this.dataset.type}-id"]`,
      )

      if (!input) return

      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  toggleAddButton (disable = true, text, modifyClass = true, enableNotify = false) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('.product-form__submitText')
    if (!addButton) return

    const discontinuedRecs = productForm.closest('quick-add-modal') ? false : document.querySelector('discontinued-recommendations')
    if (discontinuedRecs) discontinuedRecs.dataset.show = false

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
      addButton.dataset.soldOut = true
      addButton.dataset.notifyMe = false

      if (discontinuedRecs) discontinuedRecs.dataset.show = true
    } else {
      addButton.removeAttribute('disabled')
      if (enableNotify) {
        addButtonText.textContent = window.variantStrings.notifyWhenAvailable
        addButton.dataset.soldOut = true
        addButton.dataset.notifyMe = true
      } else {
        addButtonText.textContent = window.variantStrings.addToCart
        addButton.dataset.soldOut = false
        addButton.dataset.notifyMe = false
      }
    }
  }

  getAreAnyFormsInvalid () {
    return [...document.querySelectorAll('set-variant-radios')].some(form =>
      [...form.querySelectorAll('.disabled')].some(option => option.checked),
    )
  }
}

customElements.define('set-variant-radios', SetVariantRadios)

class ProductRecommendations extends HTMLElement {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
    this.pushcartRecommendations = this.hasAttribute('data-pushcart-recommendations')
  }

  connectedCallback () {
    let apiUrl = this.dataset.url

    if (apiUrl.indexOf('product_id=') !== -1) {
      const productId = apiUrl.match(/product_id=([a-z0-9-]+)/)
      if (!productId) {
        const wishlist = JSON.parse(localStorage.getItem('fostrWishlist'))
        const wishlistProductID = wishlist.products[wishlist.products.length - 1].id

        if (wishlistProductID) {
          apiUrl = apiUrl.replace('product_id=', `product_id=${wishlistProductID}`)
        }
      }
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(apiUrl)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div')
          html.innerHTML = text

          if (this.pushcartRecommendations) {
            const recommendationsRequired = this.getAttribute('data-remaining_recommendations') * 1
            let recommendationsAdded = 0
            let recommendationAlready = false

            html.querySelectorAll('.crt-Recommendations_ProductCard').forEach(card => {
              if (recommendationsAdded < recommendationsRequired) {
                const existingRecommendations = document.querySelectorAll('.crt-Recommendations_ProductCard')
                existingRecommendations.forEach(recommendationCard => {
                  if (recommendationCard.getAttribute('data-product-id') === card.getAttribute('data-product-id')) {
                    recommendationAlready = true
                  }
                })
                if (recommendationAlready === false) {
                  this.parentElement.insertBefore(card, null)
                  recommendationsAdded += 1
                }
                recommendationAlready = false
              }
            })
            this.remove()
          } else {
            const recommendations = html.querySelector('product-recommendations')

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML
            }

            if (
              !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
            ) {
              this.remove()
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded')
            }
          }
        })
        .catch(e => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this)
  }
}

customElements.define('product-recommendations', ProductRecommendations)

class RecentlyViewed extends HTMLElement {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  config = {
    maxToShow: 8,
    minToShow: 1,
    howManyToStoreInMemory: 8,
    numberProducts: 0,
    onComplete: null,
  }

  productHandleQueue = []

  cookie = {
    name: 'shopify_recently_viewed',
    write (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(','))
    },
    read () {
      let recentlyViewed = []
      const cookieValue = localStorage.getItem(this.name)
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',')
      }
      return recentlyViewed
    },
    destroy () {
      localStorage.removeItem(this.name)
    },
    remove (productHandle) {
      const recentlyViewed = this.read()
      const position = recentlyViewed.indexOf(productHandle)
      if (position !== -1) {
        recentlyViewed.splice(position, 1)
        this.write(recentlyViewed)
      }
    },
  }

  finalize = () => {
    // Add and remove classes that depend on the number of cards

    // Get elements
    const sliderComponent = this.querySelector('slider-component')
    const sliderUL = this.querySelector('slider-component ul.slider')
    const featureWrap = document.querySelector(
      `#shopify-section-${this.dataset.sectionId}.carousel__feature-wrap`,
    )
    // eslint-disable-next-line no-unused-vars
    const maxCardsToOutput = this.config.maxToShow

    // Hide buttons if cards fit
    const columnsDesktop = parseInt(this.dataset.columnsDesktop)
    const columnsMobile = parseInt(this.dataset.columnsMobile)
    let cardsFitDesktop = sliderUL.children.length <= columnsDesktop
    const cardsFitMobile = sliderUL.children.length <= columnsMobile
    const featureCardEnabled = this.dataset.feature_card_enabled === 'true'
    if (featureCardEnabled) {
      cardsFitDesktop = sliderUL.children.length < columnsDesktop
    } else {
      cardsFitDesktop = sliderUL.children.length <= columnsDesktop
    }

    if (cardsFitDesktop) {
      sliderComponent.classList.add('slider-component--cards-fit-desktop')
    } else {
      sliderComponent.classList.remove('slider-component--cards-fit-desktop')
    }

    if (cardsFitMobile) {
      sliderComponent.classList.add('slider-component--cards-fit-mobile')
    } else {
      sliderComponent.classList.remove('slider-component--cards-fit-mobile')
    }

    if (featureWrap) {
      if (cardsFitDesktop) {
        featureWrap.classList.add('carousel__feature-wrap--cards-fit-desktop')
      } else {
        featureWrap.classList.remove(
          'carousel__feature-wrap--cards-fit-desktop',
        )
      }
    }

    if (this.dataset.fullWidth === 'true') {
      // set full_width class on parent
      sliderComponent.classList.add('slider-component-full-width')
      sliderComponent.classList.remove('page-width')

      // eslint-disable-next-line no-undef
      sliderUL.prepend(li)
      // eslint-disable-next-line no-undef
      sliderUL.appendChild(li_2)
    } else {
      sliderComponent.classList.remove('slider-component-full-width')

      if (!sliderComponent.dataset.noPageWidth) {
        sliderComponent.classList.add('page-width')
      }
    }

    sliderUL.scrollLeft = 0
    this.classList.add('recently-viewed--loaded')
  }

  getRecentProducts = async () => {
    let productHandle

    if (window.location.pathname.indexOf('/products/') !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9-]+)/,
      )[1]
      this.productHandleQueue = this.productHandleQueue.filter(
        (handle) => productHandle !== handle,
      )
    }

    if (this.productHandleQueue.length < this.config.minToShow) {
      return
    }
    this.config.numberProducts = this.productHandleQueue.length

    this.productHandleQueue.length = this.config.maxToShow
    const searchRecentlyUrl =
      `/search?view=ua_recently-viewed&q=${this.productHandleQueue.toString()}`
    await fetch(searchRecentlyUrl)
      .then((response) => response.text())
      .then((html) => {
        document.querySelector(
          `#shopify-section-${this.dataset.sectionId} recently-viewed`,
        ).innerHTML = html
        this.finalize()
      })
      .catch((err) => {
        console.warn('Something went wrong.', err)
      })
  }

  recordRecentlyViewed = (values) => {
    const vals = values || {}
    let recentlyViewed = this.cookie.read()
    let productHandle
    let position

    // Update defaults.
    this.config = { ...this.config, ...vals }

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9-]+)/,
      )[1]

      position = recentlyViewed.indexOf(productHandle)

      if (position === -1) {
        recentlyViewed.unshift(productHandle)

        recentlyViewed = recentlyViewed.splice(
          0,
          this.config.howManyToStoreInMemory,
        )
      } else {
        recentlyViewed.splice(position, 1)
        recentlyViewed.unshift(productHandle)
      }

      this.cookie.write(recentlyViewed)
    }
  }

  showRecentlyViewed = (parameters) => {
    // Hide whole carousel if only tab and nothing to show
    const recentlyIsOnlyTab = this.dataset.recentlyIsOnlyTab === 'true'
    const sectionId = this.dataset.section_id
    const carousel = document.querySelector(`.carousel.section-${sectionId}`)
    const productHandlesList = localStorage.getItem(
      'shopify_recently_viewed',
    )
    if (this.dataset.onProductPage === 'true') {
      const productHandle = this.dataset.product_handle
      const noRecentlyViewed =
        !productHandlesList ||
        productHandlesList === '' ||
        productHandlesList === productHandle
      if (recentlyIsOnlyTab && noRecentlyViewed && carousel) {
        carousel.classList.add('hidden')
      } else {
        const noRecentlyViewed =
          !productHandlesList || productHandlesList === ''
        if (recentlyIsOnlyTab && noRecentlyViewed && carousel) {
          carousel.classList.add('hidden')
        }
      }
    }

    const params = parameters || {}
    // Update defaults.
    this.config = { ...this.config, ...params }

    // Read cookie.
    this.productHandleQueue = this.cookie.read()

    if (
      this.productHandleQueue === null ||
      this.productHandleQueue === undefined
    ) {
      return false
    }

    this.config.maxToShow = Math.min(
      this.productHandleQueue.length,
      this.config.maxToShow,
    )

    if (this.config.maxToShow) {
      this.getRecentProducts().then()
    }
  }

  connectedCallback () {
    this.showRecentlyViewed()
    this.recordRecentlyViewed()
  }
}

customElements.define('recently-viewed', RecentlyViewed)

// -----------Global Cookies functions---------
// setGlobalCookie('cookie_name','cookie_value', 000);
// eslint-disable-next-line no-unused-vars
function setGlobalCookie (name, value, days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`
}
// getGlobalCookie('cookie_name')
// eslint-disable-next-line no-unused-vars
function getGlobalCookie (name) {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

// eraseGlobalCookie('cookie_name')
// eslint-disable-next-line no-unused-vars
function eraseGlobalCookie (name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}
// -----------Global Cookies functions END----------

document.querySelectorAll('[href*=casa-del-mar]').forEach(x => {
  x.target = '_blank'
})

class ProductFilterFeatured {
  constructor () {
    const event = new CustomEvent('Filter_url_change')

    let previousUrl = ''

    const observer = new MutationObserver((mutations) => {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href
        window.dispatchEvent(event)
      }
    })
    const config = { subtree: true, childList: true }
    observer.observe(document, config)
  }
}
(function () {
  if (window.location.href.indexOf('/collections/') !== -1 || window.location.href.indexOf('/search?') !== -1) {
    // eslint-disable-next-line no-new
    new ProductFilterFeatured()
  }
})()

class PlpGridController extends HTMLElement {
  constructor () {
    super()

    this.gridSelectors = this.querySelectorAll('button')
    this.productGrid = document.getElementById('product-grid')

    this.gridSelectors.forEach(btn => btn.addEventListener('click', this.updateGrid.bind(this)))

    window.addEventListener('Filter_url_change', event => this.refreshSetGrid())
  }

  async updateGrid () {
    const target = event.target.closest('button')

    if (target.classList.contains('active')) return

    const selectedDisplay = target.getAttribute('data-grid-display')
    const dispatchMessage = new CustomEvent('PLP-grid-view-changed', { detail: { selectedDisplay } })

    this.gridSelectors.forEach(btn => {
      if (btn.getAttribute('data-grid-display') === selectedDisplay) {
        btn.classList.add('active')
      } else {
        btn.classList.remove('active')
      }
    })

    await this.updateLayoutKey(selectedDisplay)

    this.productGrid.setAttribute('data-plp-grid-control', target.getAttribute('data-grid-display'))

    setTimeout(() => {
      window.dispatchEvent(dispatchMessage)
    }, 100)
  }

  async updateLayoutKey (layout) {
    try {
      const formData = new FormData()
      formData.append('attributes[layout]', layout)
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
      })
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()

      return data.attributes.layout
    } catch (error) {
      console.error('Error updating the cart:', error)
    }
  }

  refreshSetGrid () {
    setTimeout(() => {
      this.productGrid = document.getElementById('product-grid')

      let setGridAs = ''

      this.gridSelectors.forEach(btn => {
        if (btn.classList.contains('active')) {
          setGridAs = btn.getAttribute('data-grid-display')
        }
      })

      this.productGrid.setAttribute('data-plp-grid-control', setGridAs)
    }, 500)
  }
}
customElements.define('plp-grid-controller', PlpGridController)

class FiltersCount extends HTMLElement {
  constructor () {
    super()

    window.addEventListener('Filter_url_change', event => this.updateCount())

    this.updateCount()
  }

  updateCount () {
    const specificType = this.getAttribute('data-specific')
    const urlParams = new URLSearchParams(window.location.search)
    let activeFilters = 0

    urlParams.forEach((value, key) => {
      if (specificType) {
        if (key === specificType) {
          activeFilters++
        }
      } else {
        if (key.startsWith('filter')) {
          activeFilters++
        }
      }
    })

    if (activeFilters > 0) {
      this.textContent = `(${activeFilters})`
    } else {
      this.textContent = ''
    }
  }
}
customElements.define('filters-count', FiltersCount)

class FilterQuicklinks extends HTMLElement {
  constructor () {
    super()

    window.addEventListener('Filter_url_change', event => this.buildLinks())

    this.buildLinks()
  }

  bindEvents () {
    this.querySelectorAll('filter-block').forEach(block => block.addEventListener('click', this.blockRemoveClick.bind(this)))
  }

  buildLinks () {
    const urlParams = new URLSearchParams(window.location.search)
    const container = this

    container.innerHTML = ''

    urlParams.forEach((value, key) => {
      if (key.startsWith('filter')) {
        const newEl = document.createElement('filter-block')
        newEl.setAttribute('tabindex', 0)
        newEl.setAttribute('data-filter-parent', key)
        newEl.setAttribute('aria-label', `Remove filter ${value}`)
        newEl.innerText = value
        container.appendChild(newEl)
      }
    })

    this.countChildren()
    this.bindEvents()
  }

  blockRemoveClick (event) {
    const removeType = event.target.getAttribute('data-filter-parent')
    const removeValue = event.target.innerText.toLowerCase()
    const removeBlock = document.querySelector(`input[name='${removeType}'][data-lowercase-value='${removeValue}']`)

    if (removeBlock) { removeBlock.click() };
    this.countChildren()
  }

  countChildren () {
    if (this.childElementCount > 0) {
      this.classList.remove('empty')
    } else {
      this.classList.add('empty')
    }
  }
}
customElements.define('filter-quicklinks', FilterQuicklinks)

class BackToSearch extends HTMLElement {
  constructor () {
    super()

    this.searchQuery = new URLSearchParams(window.location.search).get('q')
    this.backLink = this.querySelector('a')
    this.searchInput = document.querySelector('#Search-In-Modal')
    this.searchTrigger = document.querySelector('#headerSearchBarModalOpenTrigger')

    this.backLink.addEventListener('click', this.backClicked.bind(this))
  }

  backClicked (event) {
    event.preventDefault()

    this.searchInput.value = this.searchQuery
    this.searchInput.dispatchEvent(new Event('input', { bubbles: true }))

    this.searchTrigger.click()
  }
}
customElements.define('back-to-search', BackToSearch)

class recommendationAddToCart extends HTMLElement {
  constructor () {
    super()
    this.button = this.querySelector('button')
    this.prodID = this.getAttribute('data-variant-id')
    this.spanText = this.querySelector('span')
    this.loadingSpinner = this.querySelector('.loading-overlay__spinner')

    this.button.addEventListener('click', event => {
      event.stopImmediatePropagation()
      event.preventDefault()
      this.atcTrigger()
    })
  }

  atcTrigger () {
    this.spanText.classList.add('hidden')
    this.loadingSpinner.classList.remove('hidden')

    const formData = {
      items: [{
        id: this.prodID,
        quantity: 1,
      }],
    }

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(response => {
        const cart = document.querySelector('cart-drawer')
        cart.renderContents(response)
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}
customElements.define('recommendation-add-to-cart', recommendationAddToCart)

class KlaviyoReviewBanner extends HTMLElement {
  constructor () {
    super()
    this.reviewContainer = this.querySelector('#klaviyo-reviews-all')

    if (this.reviewContainer) {
      const observer = new MutationObserver((mutations) => { this.reviewsLoaded() })
      const config = { subtree: true, childList: true }
      observer.observe(this.reviewContainer, config)
    }
  }

  reviewsLoaded () {
    if (this.reviewContainer.innerText !== '') {
      this.classList.remove('prd-Reviews_no-reviews')
    }
  }
}
customElements.define('pdp-klaviyo-banner', KlaviyoReviewBanner)

class baoSizeGuide extends HTMLElement {
  constructor () {
    super()

    this.typeSelectors = this.querySelectorAll('.sec-SizeGuide_CategorySwitch input')
    this.topShapeSelectors = this.querySelectorAll('.sec-SizeGuide_TopsSwitch input')
    this.bottomShapeSelectors = this.querySelectorAll('.sec-SizeGuide_BottomsSwitch input')
    this.regionSelectors = this.querySelectorAll('.sec-SizeGuide_RegionSwitch input')
    this.metricSelectors = this.querySelectorAll('.sec-SizeGuide_ConversionSwitch input')
    this.chatButton = this.querySelector('[data-action="chat"]')
    this.findMoreInfoTopButton = this.querySelector('.sec-SizeGuide_TopsMoreInfo')
    this.findMoreInfoBtmButton = this.querySelector('.sec-SizeGuide_BottomsMoreInfo')
    this.findFitButton = this.querySelector('.sec-SizeGuide_FindFitButton')

    this.typeSelectors.forEach(input => input.addEventListener('change', this.updateType.bind(this)))
    this.topShapeSelectors.forEach(input => input.addEventListener('change', this.updateTopShape.bind(this)))
    this.bottomShapeSelectors.forEach(input => input.addEventListener('change', this.updateBottomShape.bind(this)))
    this.regionSelectors.forEach(input => input.addEventListener('change', this.updateRegion.bind(this)))
    this.metricSelectors.forEach(input => input.addEventListener('change', this.updateMetric.bind(this)))
    this.chatButton?.addEventListener('click', this.callChatWidget.bind(this))
    this.findMoreInfoTopButton?.addEventListener('click', this.findMoreInfo.bind(this))
    this.findMoreInfoBtmButton?.addEventListener('click', this.findMoreInfo.bind(this))
    this.findFitButton?.addEventListener('click', this.findFit.bind(this))
  }

  updateType (event) {
    this.setAttribute('data-product-type', event.target.value)
  }

  updateTopShape (event) {
    this.setAttribute('data-top-shape', event.target.value)
    this.setAttribute('data-top-shape-selected', 'true')
  }

  updateBottomShape (event) {
    this.setAttribute('data-bottom-shape', event.target.value)
    this.setAttribute('data-bottom-shape-selected', 'true')
  }

  updateRegion (event) {
    this.setAttribute('data-region', event.target.value)
    this.setAttribute('data-region-selected', 'true')
  }

  updateMetric (event) {
    this.setAttribute('data-metric', event.target.value)
  }

  callChatWidget (event) {
    event.preventDefault()
    const sizingModal = this.closest('#sizingGuideModal')
    if (sizingModal) {
      sizingModal.style.zIndex = 100
    }
    const quickAddModal = document.querySelector('quick-add-modal')
    if (quickAddModal) { quickAddModal.style.zIndex = 99 }
    const chatWidget = document.querySelector('.chat-widget.appear')
    if (chatWidget) {
      chatWidget.click()
    }
  }

  findMoreInfo (event) {
    event.preventDefault()
    document.querySelector(event.target.getAttribute('href')).scrollIntoView({
      behavior: 'smooth',
    })
  }

  findFit (event) {
    event.preventDefault()
    // new content coming soon
  }
}

customElements.define('bao-size-guide', baoSizeGuide)

class newSizingModal extends HTMLElement {
  constructor () {
    super()

    this.closeTrigger = this.querySelector('[data-sizing-modal-el="close"]')
    this.contactTrigger = this.querySelector('[data-action="chat"]')
    this.showSizeGuideTrigger = this.querySelector('[data-sizing-modal-el="size-guide"]')

    this.addEventListener('click', this.surroundClick.bind(this))
    this.closeTrigger.addEventListener('click', this.closeSizingModal.bind(this))
    this.contactTrigger.addEventListener('click', this.callContact.bind(this))
    this.showSizeGuideTrigger.addEventListener('click', this.closeSizingModal.bind(this))

    const previouslySeen = sessionStorage.getItem('new-sizing-shown')

    if (!previouslySeen) {
      setTimeout(() => {
        this.showSizingModal()
      }, 15000);
    }
  }

  surroundClick (e) {
    if (e.target.classList.contains('prd-SizingPopup')) {
      this.closeSizingModal()
    }
  }

  showSizingModal () {
    this.classList.add('open')
    this.closest('quick-add-modal')?.classList.add('new-size-open')
  }

  closeSizingModal () {
    sessionStorage.setItem('new-sizing-shown', true)

    this.classList.remove('open')
    this.closest('quick-add-modal')?.classList.remove('new-size-open')
  }

  callContact (event) {
    event.preventDefault()

    const quickAddModal = this.closest('quick-add-modal')

    if (quickAddModal) {
      quickAddModal.style.zIndex = 998
    }

    const sizingModalClose = document.querySelector('[data-sizing-modal-el="close"]')

    if (sizingModalClose) {
      sizingModalClose.click()
    }

    const chatWidget = document.querySelector('[data-chat-widget]')

    if (chatWidget) {
      chatWidget.click()
    }
  }
}
customElements.define('new-sizing-modal', newSizingModal)
